const rem = (px: number) => `${px / 16}rem`;
const px = (px: number) => `${px}px`;
const percentage = (value: number) => `${value}%`;

export { rem, px, percentage };
